<template>
  <div class="px-6 py-3 flex-col items-center text-center content-center h-full">
    <div v-if="loading">
      <BaseLoading :size="70" :width="7" color="#0073EF" />
    </div>
    <div v-else class="px-6 py-3 flex-col items-center text-center content-center h-full">
      <BaseIcon :icon="icon ? icon : 'info'" class="ml-2 text-blue-dark-50 text-6xl" />
      <div class="text-blue-dark-500 font-bold mt-3 text-blue-dark-500">
        {{ title }}
      </div>
      <div class="text-xs text-center mt-1 leading-normal text-blue-dark-500">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseLoading from "../base/BaseLoading.vue";
defineProps({
  icon: {
    type: String,
    default: "info",
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped></style>
